import { RichContent } from '@/components/blocks/rich-content'
import { cn } from '@/lib/utils'

/**
 * CMS-ээс ирсэн богино бичвэр — HTML эсэхээс нь хамаарч зурна.
 *
 * Зарим блокийн «Дэд гарчиг» нь rich editor-оор бөглөгддөг болсон ч
 * ихэнх нь энгийн текст хэвээр. Хоёуланг нь нэг газар шийдэв: таг агуулж
 * байвал форматлан, эс бөгөөс энгийн догол мөрөөр гаргана.
 *
 * ⚠️ HTML нь cloud тал дээр [[RichText]]-ээр цэвэрлэгдэж ирдэг.
 */
/**
 * HTML entity → тэмдэгт. Cloud талын `plainText()`-тэй ижил жагсаалт
 * (`apps/api/src/website/website-rich-text.ts:89-97`).
 */
const ENTITIES: Record<string, string> = {
  '&nbsp;': ' ',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&apos;': "'"
}

const decodeEntities = (value: string) =>
  value.replace(/&(nbsp|amp|lt|gt|quot|apos|#39);/g, match => ENTITIES[match] ?? match)

export const MaybeHtml = ({ text, className }: { text?: string | null; className?: string }) => {
  if (!text) {
    return null
  }

  if (!/<[a-z][\s\S]*>/i.test(text)) {
    /*
     * ! 🔴 ENTITY-Г ЗААВАЛ ТАЙЛНА. Энэ бичвэр cloud тал дээр `cleanHtml()`
     * ! -ээр дамжсан бөгөөд sanitize-html нь гаралтаа дахин мултруулдаг:
     * ! «Bosch & Siemens» → «Bosch &amp; Siemens». Тагийн шинжгүй тул энэ
     * ! салаанд орж, React дахин escape хийхэд хэрэглэгч «Bosch &amp;amp;
     * ! Siemens» гэж ИЛ харна.
     * !
     * ! HTML салаанд (доор) ийм асуудал гардаггүй — хөтөч entity-г өөрөө
     * ! тайлдаг.
     */
    return <p className={className}>{decodeEntities(text)}</p>
  }

  return <RichContent html={text} className={cn('[&>*:first-child]:mt-0', className)} />
}
